import { Box, FormLabel, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup } from "@mui/material";
import { Controller } from "react-hook-form";
import { FormInputProps } from "../../models/form.model";
import { SelectionOption } from "./FormSelection";

export default function FormRadioGroup(
  props: FormInputProps & {
    options: SelectionOption[];
    row?: boolean;
    dataTestId?: string;
  }
) {
  const {
    name,
    control,
    label,
    required,
    options,
    helperText,
    setError,
    rules,
    row,
    dataTestId,
    onChange: onChangeProp,
  } = props;
  const setErrorMsg = (message: string) => {
    setError(name, { type: "manual", message });
  };
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value = "" }, fieldState: { error }, formState }) => {
        return (
          <Box>
            {label && (
              <FormLabel component="legend" required={required} error={!!error}>
                {label}
              </FormLabel>
            )}
            <FormControl
              required={required}
              error={!!error}
              component="fieldset"
              sx={{
                display: "flex",
                flexDirection: row ? "row" : "column",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <RadioGroup
                value={value}
                onChange={(e) => {
                  onChange(e.target.value);
                  onChangeProp?.(e.target.value);
                }}
              >
                {options.map((v, i) => (
                  <FormControlLabel
                    key={`${v.value}`}
                    value={v.value}
                    control={<Radio />}
                    label={v.label}
                    data-testid={`${dataTestId || name}-option${i}`}
                  />
                ))}
              </RadioGroup>
              <FormHelperText error={!!error}>{error ? error.message : helperText || null}</FormHelperText>
            </FormControl>
          </Box>
        );
      }}
    />
  );
}
